export const FETCH_DESTINATIONS_REQUESTED = "FETCH_DESTINATIONS_REQUESTED";
export const FETCH_DESTINATIONS_SUCCEEDED = "FETCH_DESTINATIONS_SUCCEEDED";
export const DELETE_DESTINATION_REQUESTED = 'DELETE_DESTINATION_REQUESTED';
export const DELETE_DESTINATION_SUCCEEDED = 'DELETE_DESTINATION_SUCCEEDED';
export const FETCH_ALL_INVENTORY_OF_DESTINATION_REQUESTED = 'FETCH_ALL_INVENTORY_OF_DESTINATION_REQUESTED';
export const FETCH_ALL_INVENTORY_OF_DESTINATION_SUCCEEDED = 'FETCH_ALL_INVENTORY_OF_DESTINATION_SUCCEEDED';

